import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

import { defaultCookieDomain, deleteCookie, goAuthCookieName } from 'Containers/App/utils';
import { Button } from 'DesignLibrary/atoms';
import { sendInsightsEvent } from 'Utils/insights';

import { BaseButtonProps } from './AuthButton';

const LogoutButton = ({ children, returnToUrl = window.location.pathname, ...rest }: BaseButtonProps) => {
  const { logout, user } = useAuth0();

  const handleLogout = () => {
    window.onbeforeunload = null;
    localStorage.setItem('logoutRedirect', returnToUrl);
    sendInsightsEvent(null, 'auth_logout');
    // Auth0 clears Go's own login cookie, but not the copy Go shares with BC. Left behind, it shows
    // the next guest BC's returning-user screen.
    try {
      deleteCookie(goAuthCookieName(), defaultCookieDomain(), '/');
    } catch {
      // never block logging out
    }
    // Only SAML users also get their employer's SSO session ended; Auth0 skips it for SAML
    // connections without a Sign Out URL. Social logins are deliberately excluded, since
    // federated logout would sign a Google user out of their entire Google account.
    const signedInWithSaml = user?.sub?.startsWith('samlp|');
    logout({
      logoutParams: { returnTo: window.location.origin, ...(signedInWithSaml && { federated: true }) },
    });
  };

  return (
    <Button onClick={handleLogout} {...rest}>
      {children}
    </Button>
  );
};

export default LogoutButton;
